module.exports = __webpack_public_path__ + "img/contact.30a60019.svg";